module.exports = __webpack_public_path__ + "static/media/Congo Brazzaville.5cb841f2.png";